import { render, staticRenderFns } from "./AccreditationUploadDocBox.vue?vue&type=template&id=18fa3494&scoped=true"
import script from "./AccreditationUploadDocBox.vue?vue&type=script&lang=js"
export * from "./AccreditationUploadDocBox.vue?vue&type=script&lang=js"
import style0 from "./AccreditationUploadDocBox.vue?vue&type=style&index=0&id=18fa3494&prod&lang=scss&scoped=true"
import style1 from "./AccreditationUploadDocBox.vue?vue&type=style&index=1&id=18fa3494&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fa3494",
  null
  
)

export default component.exports